/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class amount extends IceEntity {
  amount_key: string = "";
  amount_qualifier: string = "";
  amount_value: number = 0.0;
  subscriber_key: string = "";
  coverage_key: string = "";
  payer_key: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "AMOUNT";
  }
}

